const excludedAuthPaths = ['/login', '/logout', '/otp/login', '/otp/redirect']

export default defineNuxtRouteMiddleware((_to: any, _from: any) => {
  const { isLoggedInAsContact } = useUserStore()

  if (isLoggedInAsContact) {
    // Contact-specific initialization if needed
  } else if (!excludedAuthPaths.some((path) => _to.path.includes(path))) {
    return navigateTo('/login')
  }
})
